import React from "react";
import { TextField } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

// スタイルを作成する関数
const useStyles = makeStyles({
  input: (props) => ({
    width: props.width || "100%", // 幅を指定、デフォルトは100%
    height: props.height || "auto", // 高さを指定
    fontSize: props.fontSize || "1rem", // フォントサイズを指定
  }),
  label: (props) => ({
    fontSize: props.labelFontSize || "1rem", // ラベルのフォントサイズを指定
  }),
});

const TextInputForFilter = (props) => {
  const classes = useStyles(props);

  return (
    <TextField
      fullWidth={props.fullWidth}
      label={props.label}
      margin="dense"
      multiline={props.multiline}
      required={props.required}
      rows={props.rows}
      value={props.value}
      type={props.type}
      onChange={props.onChange}
      onKeyDown={props.onKeyDown}
      disabled={props.disabled}
      placeholder={props.placeholder}
      InputProps={{
        style: {
          fontSize: props.fontSize, // フォントサイズを指定
          height: props.height, // 高さを指定
        },
        classes: {
          input: classes.input,
        },
      }}
      InputLabelProps={{
        style: {
          fontSize: props.labelFontSize, // ラベルのフォントサイズを指定
        },
        classes: {
          root: classes.label,
        },
      }}
      style={{
        width: props.width, // 幅を指定
      }}
    />
  );
};

export default TextInputForFilter;
